
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class CustomerReturnService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.cus_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_CR_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getCustomerReturnPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getCustomerReturnPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initCustomerReturnModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initCustomerReturnModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readCustomerReturn(input, responseCallBack, errorCallBack) {
    this.method("readCustomerReturn", input, responseCallBack, errorCallBack);
  }
  static updateCustomerReturn(input, responseCallBack, errorCallBack) {
    this.method("updateCustomerReturn", input, responseCallBack, errorCallBack);
  }
  static createCustomerReturn(input, responseCallBack, errorCallBack) {
    this.method("createCustomerReturn", input, responseCallBack, errorCallBack);
  }
  static createCreditMemoForCustomerReturn(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createCreditMemoForCustomerReturn",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApproveCustomerReturn(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApproveCustomerReturn",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApproveCustomerReturn(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApproveCustomerReturn",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApproveCustomerReturn(input, responseCallBack, errorCallBack) {
    this.method(
      "unApproveCustomerReturn",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockCustomerReturnNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockCustomerReturnNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelCustomerReturn(input, responseCallBack, errorCallBack) {
    this.method("cancelCustomerReturn", input, responseCallBack, errorCallBack);
  }
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.cus_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.cus_data_url,responseCallBack, errorCallBack);
    }
  }
}
